import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View, TextInput } from 'react-native';
import { i18nNS } from '../i18n';
import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from './BaseText';
import Button, { BUTTON_TYPES } from './Button';
import Modal from './Modal';
import RowView from './RowView';
import { scale } from '../utils/scale.utils';
import { validateEmail } from '../utils/common.utils';

const InputDialog = ({
  onCancel,
  onSubmit,
  label,
  defaultValue,
  visible,
  loading,
  isEmailInput = false,
}) => {
  const [value, setValue] = useState(defaultValue);
  const { t } = useTranslation(i18nNS.common);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const handleRecipientChange = (text) => {
    setIsEmailValid(validateEmail(text));
  };
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Modal visible={visible} transparent={true}>
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <BaseText style={styles.label}>{label}</BaseText>
          <TextInput
            style={styles.input}
            multiline
            value={value}
            onChangeText={(text) => {
              setValue(text);
              if (isEmailInput) {
                handleRecipientChange(text);
              }
            }}
            autoFocus
          />
          {!isEmailValid && <BaseText style={styles.errorText}>Invalid email format</BaseText>}
          <RowView style={CommonStyles.mt5}>
            <Button
              type={BUTTON_TYPES.TEXT}
              label={t('Cancel')}
              style={CommonStyles.flex1}
              labelStyle={CommonStyles.h4}
              onPress={onCancel}
              disabled={loading}
            />
            <Button
              label={t('Change')}
              style={styles.submit}
              labelStyle={[CommonStyles.h4, !isEmailValid && styles.disabled]}
              onPress={() => onSubmit(value)}
              loading={loading}
              disabled={loading || !isEmailValid}
            />
          </RowView>
        </View>
      </View>
    </Modal>
  );
};

export default InputDialog;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,.5)',
    alignItems: 'center',
    ...CommonProperties.px5,
  },
  errorText: {
    color: Color.red,
    fontSize: scale(11),
  },
  disabled: {
    color: Color.gray,
  },
  innerContainer: {
    backgroundColor: Color.accent,
    maxWidth: 480,
    width: '96%',
    ...CommonProperties.p5,
    ...CommonProperties.borderRadius2,
  },
  label: {
    ...CommonProperties.h3,
    ...CommonProperties.py3,
  },
  input: {
    borderBottomColor: Color.text.low,
    borderBottomWidth: 1,
    ...CommonProperties.h3,
    ...CommonProperties.py2,
    ...CommonProperties.mt2,
  },
  submit: {
    flex: 1,
    ...CommonProperties.ml3,
    ...CommonProperties.borderRadius3,
  },
});
